<template>
  <v-container>
    <v-tabs show-arrows dark slider-color="primary" v-model="tab">
      <v-tab>
        <v-icon left small>far fa-plus-square</v-icon>Ajouter une commande
      </v-tab>
      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="newDelivery.client"
                  :items="customers"
                  item-text="nom"
                  item-value="id_client"
                  prepend-icon="store_mall_directory"
                  label="Client"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <j-date-picker
                  v-model="newDelivery.date_envoie"
                  label="Pour la semaine du"
                ></j-date-picker>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row align="center" justify="end" no-gutters>
              <v-btn
                color="primary"
                @click="newDelivery.dialog = !newDelivery.dialog"
                :disabled="
                  newDelivery.date_envoie === null ||
                    newDelivery.client === null
                "
              >
                <v-icon left>add</v-icon>Créer
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab>Conciliation</v-tab>
      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12" sm="6">
                <v-autocomplete
                  :items="availableInvoices"
                  v-model="chequeReceive.invoiceList"
                  placeholder="Facture(s) payée(s) par le chèque"
                  multiple
                  dense
                  clearable
                  chips
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6">
                <j-date-picker
                  v-model="chequeReceive.date"
                  label="Date"
                ></j-date-picker>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row align="center" justify="end" no-gutters>
              <v-btn
                color="primary"
                :disabled="
                  chequeReceive.date === null ||
                    chequeReceive.invoiceList.length === 0
                "
                @click="updateDateEncaisse"
              >
                <v-icon class="mr-1">done</v-icon>Encaisser
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-tab-item>
      <v-tab>Bon de production</v-tab>
      <v-tab-item>
        <v-card>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <j-date-picker
                  v-model="production.date"
                  label="Pour la semaine du"
                ></j-date-picker>
              </v-col>
            </v-row>
            <ProductionPdf
              v-if="production.createProductionPdf === true"
              :customers="customers"
              :orders="delivery.filter(d => d.date_envoie === production.date)"
              :orders-qty="
                salesDetails.filter(s =>
                  delivery
                    .filter(d => d.date_envoie === production.date)
                    .map(d => d.id_commande)
                    .find(d => d === s.commande)
                )
              "
              :products="products"
              :productsPrices="productsPrices"
              :date="$moment(production.date)"
              :days="days"
              @done="production.createProductionPdf = false"
            ></ProductionPdf>
          </v-card-text>
          <v-card-actions>
            <v-row align="center" justify="end" no-gutters>
              <v-btn
                color="primary"
                :disabled="production.date === null"
                @click="production.createProductionPdf = true"
              >
                <v-icon class="mr-1">insert_drive_file</v-icon>Générer
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs>

    <v-spacer class="my-3 py-1"></v-spacer>
    <v-layout justify-end>
      <v-spacer></v-spacer>
      <v-flex xs12 sm4>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>

    <v-spacer class="my-3 py-1"></v-spacer>
    <v-card>
      <v-card-text>
        <v-data-table
          :items="data"
          :headers="headers"
          :search="search"
          :expand="expand"
          sort-by="delivery.date_envoie"
          :sort-desc="true"
          item-key="delivery.id_commande"
        >
          <template v-slot:item.order="{ item }">
            <v-btn
              text
              @click="editDelivery(item.delivery.id_commande)"
              class="align-button-text"
            >
              <v-icon>assignment</v-icon>
              # {{ item.delivery.id_commande }}
            </v-btn>
          </template>
          <template v-slot:item.report="{ item }">
            <v-btn
              text
              @click="
                addEditSalesReport(
                  item.delivery.id_commande,
                  item.report.id_rapport_vente
                )
              "
              class="align-button-text"
              v-if="item.report.id_rapport_vente !== null"
            >
              <v-icon>shopping_cart</v-icon>
              # {{ item.report.id_rapport_vente }}
            </v-btn>
            <v-btn
              text
              @click="addEditSalesReport(item.delivery.id_commande, null)"
              v-else
              class="align-button-text"
            >
              <v-icon>add_shopping_cart</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.invoice="{ item }">
            <v-hover v-if="item.invoice.id_facture !== null">
              <v-layout slot-scope="{ hover }">
                <v-btn
                  text
                  @click="getInvoicePdf(item.invoice.id_facture)"
                  class="align-button-text"
                  v-show="!hover"
                >
                  <v-icon>receipt</v-icon>
                  # {{ item.invoice.id_facture }}
                </v-btn>
                <v-btn
                  icon
                  @click="getInvoicePdf(item.invoice.id_facture)"
                  class="align-button-text"
                  v-if="hover"
                >
                  <v-icon>save_alt</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="updateInvoice(item.invoice.id_facture)"
                  class="align-button-text"
                  v-if="hover"
                >
                  <v-icon>cached</v-icon>
                </v-btn>
              </v-layout>
            </v-hover>
            <v-btn
              text
              @click="
                addInvoice(
                  item.delivery.id_commande,
                  item.report.id_rapport_vente
                )
              "
              class="align-button-text"
              v-else-if="item.report.id_rapport_vente !== null"
            >
              <v-icon>add_box</v-icon>
            </v-btn>
            <span v-else></span>
          </template>
          <template v-slot:item.loss="{ item }">
            <v-row
              align="center"
              justify="end"
              dense
              no-gutters
              style="flex-wrap: nowrap;"
              v-if="item.invoice.id_facture !== null"
            >
              <span>{{ item.invoice.mtn_perte }}</span>
              <span class="caption">$</span>
            </v-row>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <AddDeliveryDialog
      @updateTable="getData"
      :isOpen.sync="newDelivery.dialog"
      :store="getStoreId"
      :client="clientObject"
      :date="newDelivery.date_envoie"
      :products="products"
      :products-price="productsPrices"
      :client-history="clientHistory"
      :delivery-details="clientDeliverySalesDetail"
      :invoices-details="clientReportSalesDetail"
    ></AddDeliveryDialog>
    <UpdateDeliveryDialog
      @updateTable="getData"
      :isOpen.sync="updateDelivery.dialog"
      :store="getStoreId"
      :client="updateDelivery.client"
      :delivery="updateDelivery.delivery"
      :products="products"
      :products-price="productsPrices"
      :delivery-details="updateDelivery.salesDetails"
    ></UpdateDeliveryDialog>
    <SalesReportDialog
      @updateTable="getData"
      :isOpen.sync="salesReportDialog.dialog"
      :store="getStoreId"
      :client="salesReportDialog.client"
      :date="salesReportDialog.date_envoie"
      :products="products"
      :products-price="productsPrices"
      :client-history="clientHistory"
      :delivery="salesReportDialog.delivery"
      :salesReport="salesReportDialog.salesReport"
      :delivery-details="salesReportDialog.deliveryDetails"
      :report-details="salesReportDialog.salesReportDetails"
    ></SalesReportDialog>
    <v-dialog v-model="pdfLoading" max-width="40%">
      <v-card>
        <v-card-text>
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AddDeliveryDialog from "./CustomerAccountDeliveryDialog";
import UpdateDeliveryDialog from "./CustomerAccountDeliveryUpdateDialog";
import SalesReportDialog from "./CustomerAccountSalesReportDialog";
import ProductionPdf from "./CustomerAccountProduction";
import { mapGetters } from "vuex";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "CustomerAccountIndex",
  components: {
    AddDeliveryDialog,
    UpdateDeliveryDialog,
    SalesReportDialog,
    ProductionPdf
  },
  data() {
    return {
      tab: 0,
      search: "",
      expand: false,
      headers: [
        {
          value: "delivery.date_envoie",
          text: "Semaine débutant le",
          sortable: true
        },
        { value: "client.nom", text: "Client", sortable: true },
        { value: "order", text: "Commande/Livraison" },
        { value: "report", text: "Rapport des ventes" },
        { value: "invoice", text: "Facturation" },
        { value: "loss", text: "Perte" }
      ],
      data: [],
      customers: [],
      delivery: [],
      salesReport: [],
      invoices: [],
      products: [],
      images: [],
      productsPrices: [],
      salesDetails: [],
      dataLoad: {
        loading: "primary"
      },
      newDelivery: {
        nom: null,
        client: null,
        date_envoie: null,
        dateMenu: false,
        dialog: false
      },
      updateDelivery: {
        dialog: false,
        delivery: { id_commande: null },
        client: { nom: null },
        salesDetails: []
      },
      salesReportDialog: {
        dialog: false,
        delivery: { id_commande: null },
        salesReport: null,
        client: { nom: null },
        deliveryDetails: [],
        salesReportDetails: []
      },
      production: {
        date: null,
        dateMenu: false,
        createProductionPdf: false
      },
      pdfLoading: false,
      days: ["lundi", "mardi", "mercredi", "jeudi", "vendredi"],
      chequeReceive: {
        menu: false,
        date: null,
        id: null,
        invoiceList: []
      }
    };
  },
  methods: {
    allowedDates: function(val) {
      return new Date(val).getDay() === 0;
    },
    getData: async function() {
      this.data = [];
      this.dataLoad.loading = true;
      await Promise.all([
        this.getCustomer(),
        this.getDelievery(),
        this.getSalesReport(),
        this.getInvoices()
      ]);
      this.delivery.forEach(delivery => {
        let customer = this.customers.find(
          c => c.id_client === delivery.client
        );
        let report = this.salesReport.find(
          s => s.commande === delivery.id_commande
        );
        let invoice = this.invoices.find(
          i => i.commande === delivery.id_commande
        );
        this.data.push({
          client: customer,
          delivery: delivery,
          report: report || { id_rapport_vente: null },
          invoice: invoice || {
            id_facture: null,
            mtn_commande: null,
            mtn_perte: null,
            mtn_du: null,
            date_encaisse: null
          }
        });
      });
      this.getOrgImage();
      this.getProducts();
      this.getProductsPrices();
      this.getSalesDetails();
      this.dataLoad.loading = false;
    },
    getCustomer: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/customer/list/" + this.getStoreId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.customers = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getDelievery: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/delivery/list/" + this.getStoreId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.delivery = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getSalesReport: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/sales-reports/list/" + this.getStoreId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.salesReport = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getInvoices: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/invoices/list/" + this.getStoreId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.invoices = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getProducts: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/list/" + this.getStoreId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.products = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getProductsPrices: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/products/price/list/" +
          this.getStoreId +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.productsPrices = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getSalesDetails: function() {
      return new Promise(resolve => {
        const url =
          "ogari/compte-client/api/sales-details/list/" + this.getStoreId + "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.salesDetails = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    editDelivery: function(deliveryId) {
      this.updateDelivery.delivery = this.delivery.find(
        d => d.id_commande === deliveryId
      );
      this.updateDelivery.client = this.customers.find(
        c => c.id_client === this.updateDelivery.delivery.client
      );
      this.updateDelivery.salesDetails = this.salesDetails.filter(
        d => d.commande === deliveryId
      );
      this.updateDelivery.dialog = true;
    },
    addEditSalesReport: function(deliveryId, salesReportId) {
      this.salesReportDialog.delivery = this.delivery.find(
        d => d.id_commande === deliveryId
      );
      this.salesReportDialog.client = this.customers.find(
        c => c.id_client === this.salesReportDialog.delivery.client
      );
      this.salesReportDialog.deliveryDetails = this.salesDetails.filter(
        d => d.commande === deliveryId
      );
      if (salesReportId !== null) {
        this.salesReportDialog.salesReport = this.salesReport.find(
          sr => sr.id_rapport_vente === salesReportId
        );
        this.salesReportDialog.salesReportDetails = this.salesDetails.filter(
          d => d.rapport === salesReportId
        );
      } else {
        this.salesReportDialog.salesReport = null;
        this.salesReportDialog.salesReportDetails = null;
      }
      this.salesReportDialog.dialog = true;
    },
    addInvoice: function(deliveryId, salesReportId) {
      const url =
        "ogari/compte-client/api/invoices/create/" + this.getStoreId + "/";
      const config = {
        headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
      };
      const data = {
        store: this.getStoreId,
        id_commande: this.delivery.find(d => d.id_commande === deliveryId)
          .id_commande,
        id_rapport_vente: this.salesReport.find(
          sr => sr.id_rapport_vente === salesReportId
        ).id_rapport_vente
      };
      axios
        .post(url, data, config)
        .then(() => {
          this.getData();
        })
        .catch(error => {
          console.error(error);
        });
    },
    updateInvoice: function(invoiceId) {
      const url =
        "ogari/compte-client/api/invoices/update/" + this.getStoreId + "/";
      const config = {
        headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
      };
      const data = {
        store: this.getStoreId,
        id_facture: invoiceId
      };
      axios
        .put(url, data, config)
        .then(() => {
          this.getData();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getInvoicePdf: function(invoiceId) {
      this.pdfLoading = true;
      const invoice = this.invoices.find(i => i.id_facture === invoiceId);
      const commande = this.delivery.find(
        d => d.id_commande === invoice.commande
      );
      const report = this.salesReport.find(
        s => s.id_rapport_vente === invoice.rapport
      );
      const client = this.customers.find(c => invoice.client === c.id_client);
      const fileName =
        client.nom + "_#" + invoice.id_facture + "_d" + commande.date_envoie;
      let invoiceSalesDetail = this.salesDetails.filter(
        sd => sd.rapport === report.id_rapport_vente
      );
      let tableData = [
        [
          { text: "Produit", style: "tableHeader" },
          { text: "Lundi", style: "tableHeader" },
          { text: "Mardi", style: "tableHeader" },
          { text: "Mercredi", style: "tableHeader" },
          { text: "Jeudi", style: "tableHeader" },
          { text: "Vendredi", style: "tableHeader" },
          { text: "Total Vendu", style: "tableHeader" },
          { text: "Coût Unitaire", style: "tableHeaderRigth" },
          { text: "Coût Total", style: "tableHeaderRigth" }
        ]
      ];
      this.products.forEach(p => {
        let priceQuery = this.productsPrices.filter(
          pp => pp.produit === p.id_produit && pp.date <= commande.date_envoie
        );
        priceQuery.sort((a, b) => {
          if (a.date > b.date) return -1;
          if (a.date < b.date) return 1;
          return 0;
        });
        let price = p.prix;
        if (priceQuery.length !== 0) {
          price = priceQuery[0].taux;
        }
        let rowLine = [p.nom];
        let qty = 0;
        this.days.forEach(d => {
          let dailyQuery = invoiceSalesDetail.find(
            i => i.produit === p.id_produit && i.jour === d
          );
          let dailyQty =
            typeof dailyQuery !== "undefined" ? dailyQuery.quantite : 0;
          rowLine.push(dailyQty);
          qty += dailyQty;
        });
        let total = (qty * price).toFixed(2);
        rowLine.push(qty);
        rowLine.push({ text: price + " $", style: "rigthAlign" });
        rowLine.push({ text: total + " $", style: "rigthAlign" });
        if (qty > 0) {
          tableData.push(rowLine);
        }
      });
      let storeInfo = this.$store.getters["getStoreInfo"];
      let commission = invoice.mtn_commission || invoice.mtn_ap_commission;
      let tableDetailData = [
        [
          { text: "Total avant Taxe", style: "tableHeader" },
          { text: invoice.mtn_av_taxe + " $", style: "rigthAlign" }
        ],
        [
          { text: "Commission (15%)", style: "tableHeader" },
          { text: commission + " $", style: "rigthAlign" }
        ],
        [
          { text: "TPS - " + storeInfo.tps, style: "tableHeader" },
          { text: invoice.tps + " $", style: "rigthAlign" }
        ],
        [
          { text: "TVQ - " + storeInfo.tvq, style: "tableHeader" },
          { text: invoice.tvq + " $", style: "rigthAlign" }
        ],
        [
          { text: "Montant dû", style: "tableHeader" },
          { text: invoice.mtn_du + " $", style: "rigthAlign" }
        ]
      ];
      const img = this.images.find(i => i.type === "png");
      this.getDataUri(img.image, imgURI => {
        let document = {
          info: {
            title: fileName
          },
          pageOrientation: "landscape",
          content: [
            {
              columns: [
                [
                  " ",
                  {
                    text:
                      "Rapport des ventes à commission #" + invoice.id_facture,
                    style: "header"
                  },
                  {
                    text: "Client: " + client.nom,
                    style: "header"
                  },
                  " ",
                  "Lié a la commande #" +
                    commande.id_commande +
                    " de la semaine du " +
                    commande.date_envoie
                ],
                [
                  {
                    image: imgURI,
                    width: 200,
                    alignment: "right"
                  },
                  {
                    text: "Email: Ogari.factures@gmail.com",
                    style: "small"
                  },
                  {
                    text: "Teléphone: (418) 614-2050",
                    style: "small"
                  }
                ]
              ]
            },
            {
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 5,
                  x2: 763,
                  y2: 5,
                  lineWidth: 1
                }
              ]
            },
            " ",
            {
              table: {
                headerRows: 1,
                widths: [170, 50, 50, 50, 50, 50, 70, 70, 73],
                body: tableData
              },
              layout: "lightHorizontalLines"
            },
            {
              canvas: [
                {
                  type: "line",
                  x1: 0,
                  y1: 5,
                  x2: 763,
                  y2: 5,
                  lineWidth: 1
                }
              ]
            },
            " ",
            {
              columns: [
                {
                  width: 483,
                  text: " "
                },
                {
                  width: 270,
                  table: {
                    widths: [170, 100],
                    body: tableDetailData
                  },
                  layout: "noBorders"
                }
              ]
            }
          ],
          styles: {
            header: {
              fontSize: 15,
              bold: true
            },
            small: {
              fontSize: 8,
              color: "#BDBDBD",
              alignment: "right"
            },
            tableHeader: {
              bold: true,
              color: "black"
            },
            tableHeaderRigth: {
              bold: true,
              color: "black",
              alignment: "right"
            },
            rigthAlign: {
              alignment: "right"
            }
          }
        };
        pdfMake.createPdf(document).download(fileName);
        this.pdfLoading = false;
      });
    },
    getOrgImage: function() {
      return new Promise(resolve => {
        const url =
          "main/api/organisation/image/list/" +
          this.$store.getters["getOrganisationId"] +
          "/";
        const config = {
          headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
        };
        axios
          .get(url, config)
          .then(d => {
            this.images = d.data;
            resolve();
          })
          .catch(error => {
            console.error(error);
          });
      });
    },
    getDataUri: function(url, callback) {
      let image = new Image();
      image.crossOrigin = "Anonymous";
      image.onload = function() {
        let canvas = document.createElement("canvas");
        canvas.width = this.naturalWidth;
        canvas.height = this.naturalHeight;
        canvas.getContext("2d").drawImage(this, 0, 0);
        callback(canvas.toDataURL("image/png"));
      };
      image.src = url;
    },
    async updateDateEncaisse() {
      const config = {
        headers: { Authorization: "JWT " + this.$store.getters["getIdToken"] }
      };
      try {
        for (const invoice of this.chequeReceive.invoiceList) {
          const data = {
            id_facture: invoice,
            date_encaisse: this.chequeReceive.date
          };
          const url =
            "ogari/compte-client/api/invoices/patch/" +
            this.getStoreId +
            "/" +
            invoice +
            "/";
          await axios.patch(url, data, config);
        }
        this.chequeReceive.invoiceList = [];
        this.chequeReceive.date = null;
        this.getData();
        this.$dialog.notify.success(`Opération complétée avec succèes`, {
          position: "bottom-right",
          timeout: 2000
        });
      } catch (error) {
        this.$dialog.notify.error("Erreur lors de l'opération", {
          position: "bottom-right",
          timeout: 1500
        });
        console.error(error);
      }
    }
  },
  computed: {
    ...mapGetters(["getStoreId"]),
    clientObject: function() {
      return this.customers.find(c => c.id_client === this.newDelivery.client);
    },
    clientHistory: function() {
      return this.data.filter(
        d => d.client.id_client === this.newDelivery.client
      );
    },
    clientDeliverySalesDetail: function() {
      return this.salesDetails.filter(d =>
        this.clientHistory.find(ch => ch.delivery.id_commande === d.commande)
      );
    },
    clientReportSalesDetail: function() {
      return this.salesDetails.filter(d =>
        this.clientHistory.find(ch => ch.report.id_rapport_vente === d.rapport)
      );
    },
    availableInvoices: function() {
      return this.data
        .filter(d => d.invoice.date_encaisse === null)
        .map(d => d.invoice.id_facture);
    }
  }
};
</script>

<style scoped>
.v-datatable th,
.v-datatable td {
  padding: 0 5px;
}
.align-button-text {
  text-align: left;
}
</style>
